const commonLabelsMX = {
  invalidDoc: 'Documento no es válido',
};

export const rejectReasonsMX = [
  { id: '1', label: 'Falta documento área construida' },
  { id: '2', label: 'Falta de información visita operativa (Beepquest)' },
  { id: '3', label: 'Falta de documento garaje' },
  { id: '4', label: 'Documento no coincide con visita' },
  { id: '5', label: 'Documentos no legibles' },
  {
    id: '6',
    label: `${commonLabelsMX.invalidDoc} (Parámetros de comprobar veracidad)`,
  },
  { id: '7', label: 'Por Antigüedad' },
  { id: '8', label: 'Normativa Infonavit / Fovissste' },
  { id: '9', label: 'Inconsistencia en medidas (remodelaciones)' },
  { id: '10', label: 'Rechazo estructural inmobiliaria' },
  { id: '11', label: 'Rechazo lead sin datos en BDD' },
  { id: '12', label: 'Rechazo por fuera de zona Habi' },
  {
    id: '13',
    label: 'Rechazo porque registro no coincide con visita operativa',
  },
  { id: '14', label: 'Falta video de visita operativa' },
  { id: '15', label: 'Falta de área de terreno' },
  { id: '16', label: 'Descartado por ampliaciones ilegales' },
  { id: '17', label: 'Segunda Visita' },
  { id: '18', label: 'Sin documentación' },
  { id: '19', label: `${commonLabelsMX.invalidDoc} área construida` },
  { id: '20', label: `${commonLabelsMX.invalidDoc} garaje` },
  { id: '21', label: `${commonLabelsMX.invalidDoc} terreno` },
  { id: '22', label: `${commonLabelsMX.invalidDoc} antigüedad` },
  { id: '23', label: 'Daño estructural 2017' },
  {
    id: '24',
    label: 'Falta documento válido para comprobar área excedente de terreno',
  },
  {
    id: '25',
    label: 'Inconsistencia en medidas construcción (remodelaciones)',
  },
  { id: '26', label: 'Documento no contiene dirección' },
  { id: '27', label: 'Nid sin lote_id', value: 'Nid sin lote_id' },
  {
    id: '28',
    label: 'No disponible para pricing por estado',
    value: 'No disponible para pricing por estado',
  },
];
